import { RouteType } from '@/lib/route';
import VideoLibrary from '@/pages/VideoLibrary/index';

const VideoLibraryRoutes: RouteType = {
  path: '/video-library',
  component: VideoLibrary,
};

export default VideoLibraryRoutes;
